import PubSub from "pubsub-js";

let stateConfiguration = [];

function createConfiguration(name, stateConfiguration) {
  let configuration = {
    field: "",
    configurationJson: stateConfiguration,
  };

  configuration.field = name;

  return configuration;
}

function createConfigurationJson(state, field) {
  let configurationJson = {
    users: "",
    groups: "",
    text: "",
    fontFamily: "",
    fontSize: "",
    color: "",
    fontWeight: "normal",
    fontStyle: "normal",
    textDecoration: "none",
    backgroundColor: "",
    align: "",
    image: null,
    nameImage: "",
    visibility: "",
    position: "",
    sizeImage: "",
  };

  switch (field) {
    case "Logo":
      configurationJson.image = state.image;
      configurationJson.nameImage = state.nameImage;
      configurationJson.position = state.position;
      configurationJson.sizeImage = state.sizeImage;
      break;
    case "Background":
      configurationJson.backgroundColor = state.color;
      configurationJson.image = state.image;
      configurationJson.nameImage = state.nameImage;
      break;
    case "Title":
      if (typeof state !== "string") {
        configurationJson.fontFamily = state.fontFamily;
        configurationJson.fontWeight = state.fontWeight;
        configurationJson.fontStyle = state.fontStyle;
        configurationJson.textDecoration = state.textDecoration;
        configurationJson.fontSize = state.fontSize;
        configurationJson.color = state.color;
      } else {
        configurationJson.text = state;
      }
      break;
    case "Questions":
      let questions = {
        fontFamily: state?.fontFamily,
        fontWeight: state?.fontWeight,
        fontStyle: state?.fontStyle,
        textDecoration: state?.textDecoration,
        fontSize: state?.fontSize,
        color: state?.color,
      };
      configurationJson.fontFamily = questions.fontFamily;
      configurationJson.fontWeight = questions.fontWeight;
      configurationJson.fontStyle = questions.fontStyle;
      configurationJson.textDecoration = questions.textDecoration;
      configurationJson.fontSize = questions.fontSize;
      configurationJson.color = questions.color;
      break;
    case "Answer":
      let answer = {
        fontFamily: state?.fontFamily,
        fontWeight: state?.fontWeight,
        fontStyle: state?.fontStyle,
        textDecoration: state?.textDecoration,
        fontSize: state?.fontSize,
        color: state?.color,
      };
      configurationJson.fontFamily = answer.fontFamily;
      configurationJson.fontWeight = answer.fontWeight;
      configurationJson.fontStyle = answer.fontStyle;
      configurationJson.textDecoration = answer.textDecoration;
      configurationJson.fontSize = answer.fontSize;
      configurationJson.color = answer.color;
      break;
    case "TextButtonSave":
      if (typeof state !== "string") {
        configurationJson.fontFamily = state.fontFamily;
        configurationJson.fontWeight = state.fontWeight;
        configurationJson.fontStyle = state.fontStyle;
        configurationJson.textDecoration = state.textDecoration;
        configurationJson.fontSize = state.fontSize;
        configurationJson.color = state.color;
      } else if (state.indexOf("#") > -1 || state.indexOf("rgba") > -1) {
        configurationJson.backgroundColor = state;
      } else {
        configurationJson.text = state;
      }
      break;
    case "SelectedUsers":
      configurationJson.users = state;
      break;
    case "SurveyGroupIds":
      configurationJson.groups = state;
      break;
    default:
      configurationJson.text = state;
      break;
  }

  return configurationJson;
}

function updateConfigurationJson(state, field, configurationJsonAll) {
  let configurationJson = Object.assign({}, configurationJsonAll);

  switch (field) {
    case "Logo":
      configurationJson.image = state.image;
      configurationJson.nameImage = state.nameImage;
      configurationJson.position = state.position;
      configurationJson.sizeImage = state.sizeImage;
      break;
    case "Background":
      configurationJson.color = state.color;
      configurationJson.image = state.image;
      configurationJson.nameImage = state.nameImage;
      break;
    case "Title":
      if (typeof state !== "string") {
        configurationJson.fontFamily = state.fontFamily;
        configurationJson.fontWeight = state.fontWeight;
        configurationJson.fontStyle = state.fontStyle;
        configurationJson.textDecoration = state.textDecoration;
        configurationJson.fontSize = state.fontSize;
        configurationJson.color = state.color;
      } else {
        configurationJson.text = state;
      }

      break;
    case "Questions":
      let questions = {
        fontFamily: state?.fontFamily,
        fontWeight: state?.fontWeight,
        fontStyle: state?.fontStyle,
        textDecoration: state?.textDecoration,
        fontSize: state?.fontSize,
        color: state?.color,
      };
      configurationJson.fontFamily = questions.fontFamily;
      configurationJson.fontWeight = questions.fontWeight;
      configurationJson.fontStyle = questions.fontStyle;
      configurationJson.textDecoration = questions.textDecoration;
      configurationJson.fontSize = questions.fontSize;
      configurationJson.color = questions.color;
      break;
    case "Answer":
      let answer = {
        fontFamily: state?.fontFamily,
        fontWeight: state?.fontWeight,
        fontStyle: state?.fontStyle,
        textDecoration: state?.textDecoration,
        fontSize: state?.fontSize,
        color: state?.color,
      };
      configurationJson.fontFamily = answer.fontFamily;
      configurationJson.fontWeight = answer.fontWeight;
      configurationJson.fontStyle = answer.fontStyle;
      configurationJson.textDecoration = answer.textDecoration;
      configurationJson.fontSize = answer.fontSize;
      configurationJson.color = answer.color;
      break;
    case "TextButtonSave":
      if (typeof state !== "string") {
        configurationJson.fontFamily = state.fontFamily;
        configurationJson.fontWeight = state.fontWeight;
        configurationJson.fontStyle = state.fontStyle;
        configurationJson.textDecoration = state.textDecoration;
        configurationJson.fontSize = state.fontSize;
        configurationJson.color = state.color;
      } else if (state.indexOf("#") > -1 || state.indexOf("rgba") > -1) {
        configurationJson.backgroundColor = state;
      } else {
        configurationJson.text = state;
      }
      break;
    case "SelectedUsers":
      configurationJson.users = state;
      break;
    case "SurveyGroupIds":
      configurationJson.groups = state;
      break;
    default:
      configurationJson.text = state;
      break;
  }

  return configurationJson;
}

const setStateSurveyConfiguration = (state, propertie) => {
  let configurationExist = stateConfiguration.filter(
    (i) => i.field === propertie
  )[0];
  if (configurationExist) {
    configurationExist.configurationJson = updateConfigurationJson(
      state,
      propertie,
      configurationExist.configurationJson
    );
  } else {
    let newConfigurarion = createConfiguration(propertie, {});
    newConfigurarion.configurationJson = createConfigurationJson(
      state,
      propertie
    );
    stateConfiguration.push(newConfigurarion);
  }
  PubSub.publish("surveyConfiguration", stateConfiguration);
};

const initialConfiguration = (configurations) => {
  stateConfiguration = [];

  configurations.forEach((element) => {
    let jscon = JSON.parse(element.jsonConfiguration);
    stateConfiguration.push(createConfiguration(element.field, jscon));
  });
  PubSub.publish("surveyConfiguration", stateConfiguration);
};

const updateConfiguration = (configurations) => {
  let configs = [...stateConfiguration];
  configs = configs.filter((f) => {
    return (
      f.field === "SurveyGroupIds" ||
      f.field === "SelectedUsers" ||
      f.field === "surveyName" ||
      f.field === "surveyDescription"
    );
  });
  configurations.forEach((element) => {
    if (
      element.field !== "SurveyGroupIds" &&
      element.field !== "SelectedUsers" &&
      element.field !== "surveyName" &&
      element.field !== "surveyDescription"
    ) {
      let jscon = JSON.parse(element.jsonConfiguration);
      configs.push(createConfiguration(element.field, jscon));
    }
  });
  stateConfiguration = [...configs];
  PubSub.publish("surveyConfiguration", stateConfiguration);
};

export {
  updateConfiguration,
  setStateSurveyConfiguration,
  initialConfiguration,
};
